import { Card, DescriptionList, Flex, Heading, Link, Tag } from '@applyboard/crystal-ui'
import { format } from 'date-fns'
import { convertTimelessDateStrToLocalDate } from '../../../../utils/convertTimelessDateStrToLocalDate'
import { DeliveryMethod } from '../DeliveryMethod'
import { IntakeStatus } from '../IntakeStatus'
import { ProgramCardButton } from '../ProgramCardButton/ProgramCardButton'
import { ProgramLength } from '../ProgramLength'
import { IntakeSearchResource } from '@backend/agents-ui-api/resources/intake-search/types'
import { StudentApplication } from '../../../../components/Application/types'

type ProgramCardProps = {
  disabled?: boolean
  loading?: boolean
  onSubmit: () => void
  intake: IntakeSearchResource
  currentApplication: StudentApplication['attributes']
  primarySelectedProgramId?: string
  alternateProgramSelected?: string
}

export function ProgramCard(props: ProgramCardProps) {
  const headingId = crypto.randomUUID()

  function formatURL(url: string) {
    if (!url.startsWith('https://')) {
      return 'https://' + url
    }
    return url
  }

  return (
    <Card as="article" aria-labelledby={headingId}>
      <Card.Header>
        <Heading level={2} id={headingId}>
          {props.intake.attributes.program.url ? (
            <Link
              href={formatURL(props.intake.attributes.program.url)}
              mode="override_user_choice_and_open_in_new_tab"
              variant="standalone"
            >
              {props.intake.attributes.program.name}
            </Link>
          ) : (
            props.intake.attributes.program.name
          )}
        </Heading>
      </Card.Header>
      <Flex gap={4} direction="column">
        <Flex gap={2} wrap>
          {props.intake.attributes.programLevel?.name ? (
            <Tag intent="secondary">{props.intake.attributes.programLevel.name}</Tag>
          ) : null}
          <ProgramLength
            length={props.intake.attributes.program.length}
            unit={props.intake.attributes.program.lengthUnit as 'years' | 'months' | 'weeks'}
          />
          <DeliveryMethod deliveryMethod={props.intake.attributes.program.deliveryMethod} />
        </Flex>
        <DescriptionList aria-label="Program Information" variant="free">
          <Flex direction="column" gap={2}>
            <Flex justify="between" gap={1}>
              <DescriptionList.Term>Campus</DescriptionList.Term>
              <DescriptionList.Details>
                {props.intake.attributes.campus.name}
              </DescriptionList.Details>
            </Flex>
            <Flex justify="between" gap={1}>
              <DescriptionList.Term>Start</DescriptionList.Term>
              <DescriptionList.Details>
                {format(
                  convertTimelessDateStrToLocalDate(props.intake.attributes.intakeTerm.startsOn),
                  'MMM yyyy',
                )}
              </DescriptionList.Details>
            </Flex>
            <Flex justify="between" gap={1}>
              <DescriptionList.Term>Status</DescriptionList.Term>
              <DescriptionList.Details>
                <IntakeStatus size="sm" status={props.intake.attributes.intake.status} />
              </DescriptionList.Details>
            </Flex>
          </Flex>
        </DescriptionList>
      </Flex>
      <Card.Footer>
        <ProgramCardButton
          intakeSearch={props.intake}
          onClick={props.onSubmit}
          disabled={props.disabled}
          loading={props.loading}
          currentApplication={props.currentApplication}
          primarySelectedProgramId={props.primarySelectedProgramId}
          alternateProgramSelected={props.alternateProgramSelected}
        />
      </Card.Footer>
    </Card>
  )
}
